(function () {

    // ReSharper disable FunctionsUsedBeforeDeclared
    angular
        .module('smartertoolsApp')
        .controller('emailUnsubscribeController', ['$scope', '$http', 'notificationFactory', emailUnsubscribeController]);

    function emailUnsubscribeController($scope, $http, notificationFactory) {
        const vm = this;
        vm.mode = 'form';
        vm.emailAddress = null;

        // Functions
        vm.setEmail = setEmail;
        vm.doUnsubscribe = doUnsubscribe;
        activate();

        // -----------------------------------------------

        function activate() {
        }

        function setEmail(newEmail) {
            vm.emailAddress = newEmail;
        }

        function doUnsubscribe() {
            $http.post(apiRootUrl + 'v1/email/unsubscribe', JSON.stringify({Email: vm.emailAddress}))
                .then(
                    () => vm.mode = 'done',
                    (err) => notificationFactory.error('There was a problem removing this email address.  Please contact us directly for assistance.'));
        }
    }
})();